import { COUNTRY_CATALOGUE } from '../data/countries.js';
import { ELF_CATALOGUE } from '../data/legal-forms.js';
export { COUNTRY_CATALOGUE, ELF_CATALOGUE };
export const INTERNATIONAL_CATALOGUE_VERSION = 'GLEIF ELF 1.6 · 2026-02-19';
// National variants remain distinct from ELF identifiers. LARO/JN2P are inactive
// in ELF 1.6; Service-Public still documents SASU/EURL as usable company forms.
// Source and reproducible review procedure: docs/INTERNATIONAL_CATALOGUES.md.
const FRENCH_ALIASES = {
    '6CHY': 'SAS',
    V9QP: 'SARL',
    FY0F: 'SCI',
    ZY9X: 'EI',
    H1U2: 'SNC',
    DEG4: 'SCA',
    VD7Z: 'SCS',
};
export const LEGAL_FORM_CATALOGUE = [
    ...ELF_CATALOGUE.map((row) => ({
        ...row,
        abbreviation: row.abbreviation || FRENCH_ALIASES[row.code] || '',
        aliases: [...row.aliases, ...(FRENCH_ALIASES[row.code] ? [FRENCH_ALIASES[row.code]] : [])],
    })),
    ...[
        {
            code: 'FR:SASU',
            name: 'Société par actions simplifiée unipersonnelle',
            abbreviation: 'SASU',
            aliases: ['SAS à associé unique'],
        },
        {
            code: 'FR:EURL',
            name: 'Entreprise unipersonnelle à responsabilité limitée',
            abbreviation: 'EURL',
            aliases: ['SARL unipersonnelle', 'SARL à associé unique'],
        },
    ].map((row) => ({
        ...row,
        country: 'FR',
        jurisdiction: 'FR',
        jurisdictionName: 'France',
        active: true,
    })),
];
export function normalizeCatalogueSearch(value) {
    return value.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/ß/gu, 'ss').trim();
}
export function countryName(code, locale) {
    // EL/XI/UK are compatibility values, never silently rewritten in persisted data.
    const displayCode = { EL: 'GR', UK: 'GB', XI: 'GB' }[code] ?? code;
    if (!/^[A-Z]{2}$/u.test(displayCode))
        return code;
    return new Intl.DisplayNames([locale], { type: 'region' }).of(displayCode) ?? code;
}
export function countryOptions(locale, allowedCodes) {
    const source = allowedCodes === undefined
        ? COUNTRY_CATALOGUE
        : allowedCodes.map((code) => COUNTRY_CATALOGUE.find((row) => row.code === code) ?? { code, aliases: [] });
    return source
        .map((row) => ({
        id: row.code,
        label: countryName(row.code, locale),
        search: normalizeCatalogueSearch([row.code, countryName(row.code, locale), ...row.aliases].join(' ')),
    }))
        .sort((a, b) => a.label.localeCompare(b.label, locale));
}
/** Only unambiguous legacy mappings; the original enum is retained for integrations. */
export const LEGACY_ELF_CODES = {
    EK: 'OL20',
    GBR: 'FR3V',
    OHG: '40DB',
    KG: '8Z6G',
    GMBH: '2HBR',
    UG: '63KS',
    AG: '6QQB',
    SE: 'SGST',
    EG: 'AZFE',
    GESMBH: 'AXSB',
    AG_CH: 'MVII',
};
export function findLegalForm(code) {
    return LEGAL_FORM_CATALOGUE.find((row) => row.code === code);
}
export function legalFormLabel(code, otherName) {
    const form = findLegalForm(code);
    if (!form)
        return otherName || code || '';
    return [form.abbreviation, form.name].filter(Boolean).join(' · ');
}
export function legalFormApplies(code, country, jurisdiction) {
    if (code === 'OTHER')
        return true;
    const form = findLegalForm(code);
    if (!form)
        return false;
    const scope = jurisdiction || country;
    return (form.active && (form.jurisdiction === scope || (form.country === scope && !scope.includes('-'))));
}
//# sourceMappingURL=international.js.map